/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import styled from '@emotion/styled';
import { withTheme } from 'emotion-theming';

type Props = {
  awayTeam?: string,
  gameName?: string,
  highlightAway?: boolean,
  highlightHome?: boolean,
  highlightStyle: Object,
  homeTeam?: string,
  reverseOrder?: boolean
};

const defaultProps = {
  awayTeam: '',
  gameName: undefined,
  highlightAway: false,
  highlightHome: false,
  homeTeam: '',
  reverseOrder: false
};

const Team = styled.span({
  textTransform: 'uppercase'
});

function MatchUpLine({
  awayTeam,
  gameName,
  highlightAway,
  highlightHome,
  highlightStyle,
  homeTeam,
  reverseOrder
}: Props) {
  if (!awayTeam && !homeTeam) {
    return gameName ? <span>{gameName}</span> : <span>-</span>;
  }

  const away = <Team style={highlightAway ? highlightStyle : undefined}>{awayTeam}</Team>;
  const home = <Team style={highlightHome ? highlightStyle : undefined}>{homeTeam}</Team>;

  return reverseOrder ? (
    <span>
      {away} @ {home}
    </span>
  ) : (
    <span>
      {home} vs {away}
    </span>
  );
}

MatchUpLine.defaultProps = defaultProps;

const enhancer = compose(
  withTheme,
  withProps(({ theme, ...props }) => {
    const defaultHighlightStyle = {
      fontWeight: theme.fontWeight.demiBold
    };

    return {
      highlightStyle: props.highlightStyle || defaultHighlightStyle
    };
  })
);

export default enhancer(MatchUpLine);
